
export default {
  name: 'SkeepersCarousel',
  props: {
    widgetId: { type: String, required: true },
    slidesCount: { type: Number, default: 4 },
  },
  mounted() {
    if (!process.client) return
    try {
      const scriptId = `skeepers-carousel-${this.widgetId}`
      const existing = document.getElementById(scriptId)
      if (existing) existing.remove()
      const script = document.createElement('script')
      script.id = scriptId
      script.async = true
      script.charset = 'utf-8'
      script.src = `https://widgets.rr.skeepers.io/carousel/5e0737dc-e1e6-bba4-f965-f42331423733/${this.widgetId}.js`
      script.onerror = () => script.remove()
      document.body.appendChild(script)
    } catch {}
  },
}
